import { getAccessToken } from '../hooks/useAuth';

import { STORAGE_API } from '../config';

export interface UploadResult {
  id: number;
  file_url: string | null;
  thumbnail_url: string | null;
  original_filename: string;
}

export async function uploadFile(file: File, context = 'issue-intake'): Promise<UploadResult> {
  const fd = new FormData();
  fd.append('file', file, file.name);
  fd.append('context', context);
  fd.append('is_public', 'true');
  fd.append('analyze', 'false');

  const headers = new Headers();
  const token = getAccessToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);

  if (!STORAGE_API) {
    throw new Error('Storage ist auf dieser Instanz nicht konfiguriert (VITE_STORAGE_API)');
  }
  const res = await fetch(`${STORAGE_API}/storage/upload`, {
    method: 'POST',
    headers,
    body: fd,
  });
  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`storage upload ${res.status}: ${detail.slice(0, 200)}`);
  }
  return (await res.json()) as UploadResult;
}
